import { listLocations } from '../../../../util/APIUtils';
import { USER_CONTEXT } from '../../../../constants';

export const fetchLocations = async () => {
  try {
    const postBody = {
      requestorId: USER_CONTEXT.personId,
      filterLocationTypeIds: [],
      filterLocationIds: []
    };
    const response = await listLocations(JSON.stringify(postBody));
    return response;
  } catch (error) {
    throw error;
  }
};
